export default {
  baseConfig: {
    companyID: '4160',
    siteZone: 'mv.fc'
  },
  priorityTags: {
    _custom: {
      slug: '_custom',
      category: 'advertorial'
    },
    _syndicated: {
      slug: '_syndicated',
      category: 'advertorial'
    },
    _brandview: {
      slug: '_brandview',
      category: 'advertorial'
    },
    'a-green-new-deal-for-business': {
      slug: 'a-green-new-deal-for-business',
      category: 'misc'
    },
    '2020-election': {
      slug: '2020-election',
      category: 'misc'
    },
    '30-second-mba': {
      slug: '30-second-mba',
      category: 'studio'
    },
    '25th-anniversary': {
      slug: '25th-anniversary',
      category: 'misc'
    },
    'a-leap-forward': {
      slug: 'a-leap-forward',
      category: 'advertorial'
    },
    'abortion-access': {
      slug: 'abortion-access',
      category: 'work life'
    },
    accelerator: {
      slug: 'accelerator',
      category: 'technology'
    },
    'ad-of-the-day': {
      slug: 'ad-of-the-day',
      category: 'misc'
    },
    adops: {
      slug: 'adops',
      category: 'misc'
    },
    afghanistan: {
      slug: 'afghanistan',
      category: 'misc'
    },
    agendas: {
      slug: 'agendas',
      category: 'misc'
    },
    'all-stars': {
      slug: 'all-stars',
      category: 'misc'
    },
    'almost-genius': {
      slug: 'almost-genius',
      category: 'misc'
    },
    analyzed: {
      slug: 'analyzed',
      category: 'misc'
    },
    'app-economy': {
      slug: 'app-economy',
      category: 'misc'
    },
    'apple-event': {
      slug: 'apple-event',
      category: 'misc'
    },
    asides: {
      slug: 'asides',
      category: 'misc'
    },
    'ask-the-experts': {
      slug: 'ask-the-experts',
      category: 'misc'
    },
    'awful-or-awesome': {
      slug: 'awful-or-awesome',
      category: 'misc'
    },
    badvocacy: {
      slug: 'badvocacy',
      category: 'misc'
    },
    bananas: {
      slug: 'bananas',
      category: 'misc'
    },
    'behind-the-brand': {
      slug: 'behind-the-brand',
      category: 'leadership'
    },
    'beside-great-leaders': {
      slug: 'beside-great-leaders',
      category: 'advertorial'
    },
    'big-bang-design': {
      slug: 'big-bang-design',
      category: 'misc'
    },
    biomimicry: {
      slug: 'biomimicry',
      category: 'innovation'
    },
    'big-ideas-for-the-first-100-days': {
      slug: 'big-ideas-for-the-first-100-days',
      category: 'misc'
    },
    'biz-of-youtube': {
      slug: 'biz-of-youtube',
      category: 'misc'
    },
    'black-in-tech': {
      slug: 'black-in-tech',
      category: 'misc'
    },
    'body-os': {
      slug: 'body-os',
      category: 'technology'
    },
    'body-week': {
      slug: 'body-week',
      category: 'misc'
    },
    'bottom-line': {
      slug: 'bottom-line',
      category: 'leadership'
    },
    'brand-evolution': {
      slug: 'brand-evolution',
      category: 'studio'
    },
    'breaking-the-status-quo': {
      slug: 'breaking-the-status-quo',
      category: 'misc'
    },
    'breakthrough-capitalism': {
      slug: 'breakthrough-capitalism',
      category: 'misc'
    },
    'brilliant-minds': {
      slug: 'brilliant-minds',
      category: 'advertorial'
    },
    'bugaboo-boxer': {
      slug: 'bugaboo-boxer',
      category: 'advertorial'
    },
    'build-a-business': {
      slug: 'build-a-business',
      category: 'leadership'
    },
    'builders-and-innovators': {
      slug: 'builders-and-innovators',
      category: 'advertorial'
    },
    'building-back-greener': {
      slug: 'building-back-greener',
      category: 'misc'
    },
    'business-of-tech': {
      slug: 'business-of-tech',
      category: 'technology'
    },
    'business-simplified': {
      slug: 'business-simplified',
      category: 'advertorial'
    },
    'butterfly-effect': {
      slug: 'butterfly-effect',
      category: 'technology'
    },
    buyology: {
      slug: 'buyology',
      category: 'innovation'
    },
    cannes: {
      slug: 'cannes',
      category: 'misc'
    },
    'career-evolution': {
      slug: 'career-evolution',
      category: 'misc'
    },
    'ceelo-most-creative-videos': {
      slug: 'ceelo-most-creative-videos',
      category: 'studio'
    },
    'change-agents': {
      slug: 'change-agents',
      category: 'advertorial'
    },
    'change-generation': {
      slug: 'change-generation',
      category: 'innovation'
    },
    'climate-change-survival-plan': {
      slug: 'climate-change-survival-plan',
      category: 'misc'
    },
    'closer-to-next': {
      slug: 'closer-to-next',
      category: 'advertorial'
    },
    'co-creators': {
      slug: 'co-creators',
      category: 'misc'
    },
    'code-art': {
      slug: 'code-art',
      category: 'codesign'
    },
    'co-location': {
      slug: 'co-location',
      category: 'misc'
    },
    'coexists-2015-in-review': {
      slug: 'coexists-2015-in-review',
      category: 'misc'
    },
    'coexists-2016-in-review': {
      slug: 'coexists-2016-in-review',
      category: 'misc'
    },
    'coffee-week': {
      slug: 'coffee-week',
      category: 'misc'
    },
    'colabs-classes': {
      slug: 'colabs-classes',
      category: 'misc'
    },
    'connected-world': {
      slug: 'connected-world',
      category: 'misc'
    },
    'conquering-the-cloud': {
      slug: 'conquering-the-cloud',
      category: 'advertorial'
    },
    'conquering-the-cloud-test': {
      slug: 'conquering-the-cloud-test',
      category: 'misc'
    },
    coronavirus: {
      slug: 'coronavirus',
      category: 'misc'
    },
    'queer-50': {
      slug: 'queer-50',
      category: 'misc'
    },
    'content-and-pervasive-creativity': {
      slug: 'content-and-pervasive-creativity',
      category: 'advertorial'
    },
    'creating-happiness': {
      slug: 'creating-happiness',
      category: 'misc'
    },
    'creation-stories': {
      slug: 'creation-stories',
      category: 'misc'
    },
    'creative-braintrust': {
      slug: 'creative-braintrust',
      category: 'misc'
    },
    'creative-braintrust-test': {
      slug: 'creative-braintrust-test',
      category: 'misc'
    },
    'creative-calendar': {
      slug: 'creative-calendar',
      category: 'misc'
    },
    'creative-control': {
      slug: 'creative-control',
      category: 'misc'
    },
    'creative-conversations': {
      slug: 'creative-conversations',
      category: 'misc'
    },
    'creative-counselor': {
      slug: 'creative-counselor',
      category: 'misc'
    },
    'creative-cultures': {
      slug: 'creative-cultures',
      category: 'misc'
    },
    'creative-defiance': {
      slug: 'creative-defiance',
      category: 'misc'
    },
    'creative-destination': {
      slug: 'creative-destination',
      category: 'misc'
    },
    'creativity-by-the-numbers': {
      slug: 'creativity-by-the-numbers',
      category: 'misc'
    },
    'creators-profile': {
      slug: 'creators-profile',
      category: 'misc'
    },
    'davos-dialogues': {
      slug: 'davos-dialogues',
      category: 'misc'
    },
    'day-on-day-off': {
      slug: 'day-on-day-off',
      category: 'misc'
    },
    'dear-founder': {
      slug: 'dear-founder',
      category: 'misc'
    },
    'defining-moments-visualized': {
      slug: 'defining-moments-visualized',
      category: 'advertorial'
    },
    'design-50': {
      slug: 'design-50',
      category: 'misc'
    },
    'design-award': {
      slug: 'design-award',
      category: 'advertorial'
    },
    'design-crime': {
      slug: 'design-crime',
      category: 'misc'
    },
    'design-for-living': {
      slug: 'design-for-living',
      category: 'misc'
    },
    'design-moves': {
      slug: 'design-moves',
      category: 'misc'
    },
    'designed-for-success': {
      slug: 'designed-for-success',
      category: 'advertorial'
    },
    'designing-women': {
      slug: 'designing-women',
      category: 'misc'
    },
    'destination-design': {
      slug: 'destination-design',
      category: 'advertorial'
    },
    'destination-entrepreneurs': {
      slug: 'destination-entrepreneurs',
      category: 'misc'
    },
    'destinations-uncovered': {
      slug: 'destinations-uncovered',
      category: 'advertorial'
    },
    dialed: {
      slug: 'dialed',
      category: 'leadership'
    },
    'difficult-conversations': {
      slug: 'difficult-conversations',
      category: 'misc'
    },
    'digital-hollywood': {
      slug: 'digital-hollywood',
      category: 'misc'
    },
    'digital-trailblazers': {
      slug: 'digital-trailblazers',
      category: 'advertorial'
    },
    'dispatch-from': {
      slug: 'dispatch-from',
      category: 'advertorial'
    },
    'do-more': {
      slug: 'do-more',
      category: 'advertorial'
    },
    'doubting-the-dose': {
      slug: 'doubting-the-dose',
      category: 'misc'
    },
    'drive-your-business-forward': {
      slug: 'drive-your-business-forward',
      category: 'advertorial'
    },
    'driving-innovation': {
      slug: 'driving-innovation',
      category: 'innovation'
    },
    'drone-vs': {
      slug: 'drone-vs',
      category: 'misc'
    },
    'dynamic-dialogues': {
      slug: 'dynamic-dialogues',
      category: 'advertorial'
    },
    elasticity: {
      slug: 'elasticity',
      category: 'misc'
    },
    'election-2016': {
      slug: 'election-2016',
      category: 'misc'
    },
    'electric-avenue': {
      slug: 'electric-avenue',
      category: 'misc'
    },
    'elevator-pitch': {
      slug: 'elevator-pitch',
      category: 'advertorial'
    },
    'engineering-creativity': {
      slug: 'engineering-creativity',
      category: 'advertorial'
    },
    'ethonomic-indicator': {
      slug: 'ethonomic-indicator',
      category: 'misc'
    },
    events: {
      slug: 'events',
      category: 'misc'
    },
    evidence: {
      slug: 'evidence',
      category: 'misc'
    },
    exclusive: {
      slug: 'exclusive',
      category: 'misc'
    },
    'exclusive-video': {
      slug: 'exclusive-video',
      category: 'misc'
    },
    experiments: {
      slug: 'experiments',
      category: 'misc'
    },
    exposure: {
      slug: 'exposure',
      category: 'misc'
    },
    'faces-of-founders': {
      slug: 'faces-of-founders',
      category: 'advertorial'
    },
    'fashion-forward': {
      slug: 'fashion-forward',
      category: 'misc'
    },
    'fast-cities': {
      slug: 'fast-cities',
      category: 'innovation'
    },
    'fast-company-live': {
      slug: 'fast-company-live',
      category: 'misc'
    },
    'fast-feed': {
      slug: 'fast-feed',
      category: 'misc'
    },
    'fast-forward': {
      slug: 'fast-forward',
      category: 'misc'
    },
    'fast-forward-workday': {
      slug: 'fast-forward-workday',
      category: 'advertorial'
    },
    'fast-government': {
      slug: 'fast-government',
      category: 'misc'
    },
    'fast-take': {
      slug: 'fast-take',
      category: 'misc'
    },
    'fast-talk': {
      slug: 'fast-talk',
      category: 'misc'
    },
    fastcoworks: {
      slug: 'fastcoworks',
      category: 'misc'
    },
    'feeding-the-future': {
      slug: 'feeding-the-future',
      category: 'misc'
    },
    'financing-the-future': {
      slug: 'financing-the-future',
      category: 'misc'
    },
    'find-your-values': {
      slug: 'find-your-values',
      category: 'leadership'
    },
    'first-look': {
      slug: 'first-look',
      category: 'misc'
    },
    'food-week': {
      slug: 'food-week',
      category: 'misc'
    },
    'fund-this': {
      slug: 'fund-this',
      category: 'innovation'
    },
    'future-forward': {
      slug: 'future-forward',
      category: 'misc'
    },
    'future-of-philanthropy': {
      slug: 'future-of-philanthropy',
      category: 'misc'
    },
    'future-of-retail': {
      slug: 'future-of-retail',
      category: 'technology'
    },
    'future-proof': {
      slug: 'future-proof',
      category: 'misc'
    },
    'futurist-forum': {
      slug: 'futurist-forum',
      category: 'innovation'
    },
    'generation-flux': {
      slug: 'generation-flux',
      category: 'technology'
    },
    'generosity-series': {
      slug: 'generosity-series',
      category: 'misc'
    },
    'genius-marketing': {
      slug: 'genius-marketing',
      category: 'misc'
    },
    'getting-funded': {
      slug: 'getting-funded',
      category: 'misc'
    },
    'gif-of-the-day': {
      slug: 'gif-of-the-day',
      category: 'misc'
    },
    'gift-guide': {
      slug: 'gift-guide',
      category: 'misc'
    },
    gigged: {
      slug: 'gigged',
      category: 'misc'
    },
    'good-design-is-good-business': {
      slug: 'good-design-is-good-business',
      category: 'innovation'
    },
    'greatest-geek-moment-in-history': {
      slug: 'greatest-geek-moment-in-history',
      category: 'misc'
    },
    'growth-hacking': {
      slug: 'growth-hacking',
      category: 'advertorial'
    },
    'growth-notes': {
      slug: 'growth-notes',
      category: 'advertorial'
    },
    'hackers-we-love': {
      slug: 'hackers-we-love',
      category: 'misc'
    },
    'hacking-democracy': {
      slug: 'hacking-democracy',
      category: 'misc'
    },
    healthware: {
      slug: 'healthware',
      category: 'technology'
    },
    help: {
      slug: 'help',
      category: 'misc'
    },
    'heres-an-idea': {
      slug: 'heres-an-idea',
      category: 'innovation'
    },
    'hit-the-ground-running': {
      slug: 'hit-the-ground-running',
      category: 'misc'
    },
    'holiday-gift-guide': {
      slug: 'holiday-gift-guide',
      category: 'misc'
    },
    'work-in-2040': {
      slug: 'work-in-2040',
      category: 'misc'
    },
    'home-bound': {
      slug: 'home-bound',
      category: 'misc'
    },
    'homebrew-news': {
      slug: 'homebrew-news',
      category: 'misc'
    },
    'hotel-revolution': {
      slug: 'hotel-revolution',
      category: 'advertorial'
    },
    'how-i-get-it-done': {
      slug: 'how-i-get-it-done',
      category: 'leadership'
    },
    'how-healthy-is-the-future-of-work': {
      slug: 'how-healthy-is-the-future-of-work',
      category: 'misc'
    },
    'how-to-be-a-success-at-everything': {
      slug: 'how-to-be-a-success-at-everything',
      category: 'leadership'
    },
    'how-to-build-the-perfect-city': {
      slug: 'how-to-build-the-perfect-city',
      category: 'misc'
    },
    'hows-that-working-out-for-you': {
      slug: 'hows-that-working-out-for-you',
      category: 'misc'
    },
    hr: {
      slug: 'hr',
      category: 'misc'
    },
    ifive: {
      slug: 'ifive',
      category: 'misc'
    },
    'ignite-positive-change': {
      slug: 'ignite-positive-change',
      category: 'leadership'
    },
    'image-of-the-day': {
      slug: 'image-of-the-day',
      category: 'misc'
    },
    'industrial-internet': {
      slug: 'industrial-internet',
      category: 'advertorial'
    },
    'industries-to-watch': {
      slug: 'industries-to-watch',
      category: 'innovation'
    },
    'industry-pov': {
      slug: 'industry-pov',
      category: 'innovation'
    },
    'influence-project': {
      slug: 'influence-project',
      category: 'misc'
    },
    'influencer-collective': {
      slug: 'influencer-collective',
      category: 'misc'
    },
    'infographic-of-the-day': {
      slug: 'infographic-of-the-day',
      category: 'misc'
    },
    innovation360: {
      slug: 'innovation360',
      category: 'technology'
    },
    'innovation-agents': {
      slug: 'innovation-agents',
      category: 'misc'
    },
    'innovation-by-design': {
      slug: 'innovation-by-design',
      category: 'misc'
    },
    'innovation-by-design-2014': {
      slug: 'innovation-by-design-2014',
      category: 'misc'
    },
    'innovation-by-design-awards': {
      slug: 'innovation-by-design-awards',
      category: 'misc'
    },
    'innovation-by-design-awards-2014': {
      slug: 'innovation-by-design-awards-2014',
      category: 'misc'
    },
    'innovation-by-design-awards-2015': {
      slug: 'innovation-by-design-awards-2015',
      category: 'misc'
    },
    'innovation-by-design-awards-entries-2014': {
      slug: 'innovation-by-design-awards-entries-2014',
      category: 'misc'
    },
    'innovation-by-design-awards-entries-2015': {
      slug: 'innovation-by-design-awards-entries-2015',
      category: 'misc'
    },
    'innovation-by-design-conference': {
      slug: 'innovation-by-design-conference',
      category: 'misc'
    },
    'impact-council': {
      slug: 'impact-council',
      category: 'misc'
    },
    'innovation-enabled': {
      slug: 'innovation-enabled',
      category: 'misc'
    },
    'innovation-engine': {
      slug: 'innovation-engine',
      category: 'misc'
    },
    'innovation-festival-360': {
      slug: 'innovation-festival-360',
      category: 'misc'
    },
    'innovation-nation': {
      slug: 'innovation-nation',
      category: 'misc'
    },
    'innovation-pipeline': {
      slug: 'innovation-pipeline',
      category: 'misc'
    },
    'innovation-uncensored-sf-2014': {
      slug: 'innovation-uncensored-sf-2014',
      category: 'misc'
    },
    'inside-smart-cities': {
      slug: 'inside-smart-cities',
      category: 'misc'
    },
    'experience-economy': {
      slug: 'experience-economy',
      category: 'misc'
    },
    'insider-insight': {
      slug: 'insider-insight',
      category: 'misc'
    },
    'inspiration-and-impact': {
      slug: 'inspiration-and-impact',
      category: 'advertorial'
    },
    'inspired-ethonomics': {
      slug: 'inspired-ethonomics',
      category: 'misc'
    },
    'internet-of-things': {
      slug: 'internet-of-things',
      category: 'misc'
    },
    'isle-of-innovation': {
      slug: 'isle-of-innovation',
      category: 'advertorial'
    },
    'its-good-not-to-be-home': {
      slug: 'its-good-not-to-be-home',
      category: 'advertorial'
    },
    'know-it-all': {
      slug: 'know-it-all',
      category: 'misc'
    },
    'leadership-now': {
      slug: 'leadership-now',
      category: 'misc'
    },
    'league-of-extraordinary-women-2012': {
      slug: 'league-of-extraordinary-women-2012',
      category: 'leadership'
    },
    'lessons-learned': {
      slug: 'lessons-learned',
      category: 'innovation'
    },
    'let-it-fly': {
      slug: 'let-it-fly',
      category: 'advertorial'
    },
    'life-in-beta': {
      slug: 'life-in-beta',
      category: 'innovation'
    },
    'living-smarter': {
      slug: 'living-smarter',
      category: 'leadership'
    },
    'location-location-location': {
      slug: 'location-location-location',
      category: 'misc'
    },
    'lorem-ipsum': {
      slug: 'lorem-ipsum',
      category: 'misc'
    },
    'made-to-stick': {
      slug: 'made-to-stick',
      category: 'misc'
    },
    'make-a-name': {
      slug: 'make-a-name',
      category: 'misc'
    },
    'make-your-move': {
      slug: 'make-your-move',
      category: 'misc'
    },
    'making-it': {
      slug: 'making-it',
      category: 'innovation'
    },
    'making-your-workplace-work': {
      slug: 'making-your-workplace-work',
      category: 'misc'
    },
    maps: {
      slug: 'maps',
      category: 'misc'
    },
    'mark-bittman': {
      slug: 'mark-bittman',
      category: 'misc'
    },
    'marketing-innovation': {
      slug: 'marketing-innovation',
      category: 'misc'
    },
    'master-class': {
      slug: 'master-class',
      category: 'misc'
    },
    'masters-of-design': {
      slug: 'masters-of-design',
      category: 'misc'
    },
    'masters-of-design-2005': {
      slug: 'masters-of-design-2005',
      category: 'misc'
    },
    'masters-of-design-2006': {
      slug: 'masters-of-design-2006',
      category: 'misc'
    },
    'masters-of-design-2007': {
      slug: 'masters-of-design-2007',
      category: 'misc'
    },
    'masters-of-design-2008': {
      slug: 'masters-of-design-2008',
      category: 'misc'
    },
    'masters-of-design-2009': {
      slug: 'masters-of-design-2009',
      category: 'misc'
    },
    'masters-of-design-2010': {
      slug: 'masters-of-design-2010',
      category: 'misc'
    },
    'masters-of-design-2011': {
      slug: 'masters-of-design-2011',
      category: 'misc'
    },
    'masters-of-marketing': {
      slug: 'masters-of-marketing',
      category: 'misc'
    },
    meme: {
      slug: 'meme',
      category: 'misc'
    },
    'mind-and-machine': {
      slug: 'mind-and-machine',
      category: 'misc'
    },
    'mental-health-at-work': {
      slug: 'mental-health-at-work',
      category: 'misc'
    },
    mobilizing: {
      slug: 'mobilizing',
      category: 'misc'
    },
    'most-creative-people': {
      slug: 'most-creative-people',
      category: 'leadership'
    },
    'mindfulness-at-work': {
      slug: 'mindfulness-at-work',
      category: 'misc'
    },
    'misinformation-nation': {
      slug: 'misinformation-nation',
      category: 'misc'
    },
    'most-creative-people-2009': {
      slug: 'most-creative-people-2009',
      category: 'leadership'
    },
    'most-creative-people-2010': {
      slug: 'most-creative-people-2010',
      category: 'leadership'
    },
    'most-creative-people-2011': {
      slug: 'most-creative-people-2011',
      category: 'leadership'
    },
    'most-creative-people-2012': {
      slug: 'most-creative-people-2012',
      category: 'leadership'
    },
    'most-creative-people-2013': {
      slug: 'most-creative-people-2013',
      category: 'leadership'
    },
    'most-creative-people-2014': {
      slug: 'most-creative-people-2014',
      category: 'leadership'
    },
    'most-creative-people-2015': {
      slug: 'most-creative-people-2015',
      category: 'leadership'
    },
    'most-innovative-companies': {
      slug: 'most-innovative-companies',
      category: 'misc'
    },
    'most-innovative-moments': {
      slug: 'most-innovative-moments',
      category: 'innovation'
    },
    'moving-the-needle': {
      slug: 'moving-the-needle',
      category: 'innovation'
    },
    'my-creative-life': {
      slug: 'my-creative-life',
      category: 'misc'
    },
    'my-way': {
      slug: 'my-way',
      category: 'misc'
    },
    'new-heights': {
      slug: 'new-heights',
      category: 'misc'
    },
    'new-money': {
      slug: 'new-money',
      category: 'misc'
    },
    'next-design': {
      slug: 'next-design',
      category: 'innovation'
    },
    'next-gen-design': {
      slug: 'next-gen-design',
      category: 'advertorial'
    },
    'objet-dinternet': {
      slug: 'objet-dinternet',
      category: 'misc'
    },
    'olympics-2012': {
      slug: 'olympics-2012',
      category: 'misc'
    },
    'one-more-thing': {
      slug: 'one-more-thing',
      category: 'misc'
    },
    'open-company': {
      slug: 'open-company',
      category: 'misc'
    },
    'out-of-office-with': {
      slug: 'out-of-office-with',
      category: 'leadership'
    },
    'passion-to-profit': {
      slug: 'passion-to-profit',
      category: 'misc'
    },
    'pet-week': {
      slug: 'pet-week',
      category: 'misc'
    },
    'platform-wars': {
      slug: 'platform-wars',
      category: 'misc'
    },
    politechs: {
      slug: 'politechs',
      category: 'misc'
    },
    pov: {
      slug: 'pov',
      category: 'leadership'
    },
    'power-couples': {
      slug: 'power-couples',
      category: 'misc'
    },
    'power-of-ai': {
      slug: 'power-of-ai',
      category: 'advertorial'
    },
    'powering-the-future': {
      slug: 'powering-the-future',
      category: 'innovation'
    },
    'productivity-in-motion': {
      slug: 'productivity-in-motion',
      category: 'advertorial'
    },
    'progress-is-possible': {
      slug: 'progress-is-possible',
      category: 'advertorial'
    },
    'project-fusion': {
      slug: 'project-fusion',
      category: 'advertorial'
    },
    qa: {
      slug: 'qa',
      category: 'misc'
    },
    'quick-hit': {
      slug: 'quick-hit',
      category: 'misc'
    },
    'reading-list': {
      slug: 'reading-list',
      category: 'misc'
    },
    'rebranding-pot': {
      slug: 'rebranding-pot',
      category: 'misc'
    },
    'reinventing-music': {
      slug: 'reinventing-music',
      category: 'misc'
    },
    'reinventing-education': {
      slug: 'reinventing-education',
      category: 'misc'
    },
    retrology: {
      slug: 'retrology',
      category: 'misc'
    },
    'restaurant-diaries': {
      slug: 'restaurant-diaries',
      category: 'misc'
    },
    'reverse-engineered': {
      slug: 'reverse-engineered',
      category: 'misc'
    },
    'revision-history': {
      slug: 'revision-history',
      category: 'misc'
    },
    'revolutionizing-work': {
      slug: 'revolutionizing-work',
      category: 'advertorial'
    },
    'rhone-technology': {
      slug: 'rhone-technology',
      category: 'advertorial'
    },
    'risks-visualized': {
      slug: 'risks-visualized',
      category: 'advertorial'
    },
    'robot-revolution': {
      slug: 'robot-revolution',
      category: 'misc'
    },
    'running-lean': {
      slug: 'running-lean',
      category: 'misc'
    },
    'second-shift': {
      slug: 'second-shift',
      category: 'misc'
    },
    'secrets-of-the-most-productive-people': {
      slug: 'secrets-of-the-most-productive-people',
      category: 'misc'
    },
    'sector-forecasting': {
      slug: 'sector-forecasting',
      category: 'innovation'
    },
    'seth-bodnar-ge': {
      slug: 'seth-bodnar-ge',
      category: 'misc'
    },
    'show-up-differently': {
      slug: 'show-up-differently',
      category: 'advertorial'
    },
    'side-project': {
      slug: 'side-project',
      category: 'misc'
    },
    'signs-and-symbols': {
      slug: 'signs-and-symbols',
      category: 'leadership'
    },
    'silicon-valley-social-entrepreneurs': {
      slug: 'silicon-valley-social-entrepreneurs',
      category: 'misc'
    },
    'simple-genius': {
      slug: 'simple-genius',
      category: 'misc'
    },
    'sleep-week': {
      slug: 'sleep-week',
      category: 'misc'
    },
    'slicker-city': {
      slug: 'slicker-city',
      category: 'misc'
    },
    'small-to-fast': {
      slug: 'small-to-fast',
      category: 'misc'
    },
    'smart-cities': {
      slug: 'smart-cities',
      category: 'misc'
    },
    'solutions-initiative': {
      slug: 'solutions-initiative',
      category: 'misc'
    },
    'solving-inequality': {
      slug: 'solving-inequality',
      category: 'misc'
    },
    spark: {
      slug: 'spark',
      category: 'misc'
    },
    'startup-report': {
      slug: 'startup-report',
      category: 'misc'
    },
    storytellers: {
      slug: 'storytellers',
      category: 'misc'
    },
    'strong-female-lead': {
      slug: 'strong-female-lead',
      category: 'misc'
    },
    'style-revolution': {
      slug: 'style-revolution',
      category: 'advertorial'
    },
    'super-bowl-50': {
      slug: 'super-bowl-50',
      category: 'misc'
    },
    'super-bowl-li': {
      slug: 'super-bowl-li',
      category: 'misc'
    },
    'super-bowl-xlix': {
      slug: 'super-bowl-xlix',
      category: 'misc'
    },
    'super-bowl-xlvi': {
      slug: 'super-bowl-xlvi',
      category: 'misc'
    },
    'super-bowl-xlvii': {
      slug: 'super-bowl-xlvii',
      category: 'misc'
    },
    'super-bowl-xlviii': {
      slug: 'super-bowl-xlviii',
      category: 'misc'
    },
    'superlatives-week': {
      slug: 'superlatives-week',
      category: 'misc'
    },
    'supertag-test-multiple-sites': {
      slug: 'supertag-test-multiple-sites',
      category: 'misc'
    },
    'lessons-of-covid': {
      slug: 'lessons-of-covid',
      category: 'misc'
    },
    'lessons-of-covid-19': {
      slug: 'lessons-of-covid-19',
      category: 'misc'
    },
    sxsw: {
      slug: 'sxsw',
      category: 'misc'
    },
    'sxsw-2016': {
      slug: 'sxsw-2016',
      category: 'misc'
    },
    'tech-edge': {
      slug: 'tech-edge',
      category: 'misc'
    },
    'tech-forecast': {
      slug: 'tech-forecast',
      category: 'misc'
    },
    technovore: {
      slug: 'technovore',
      category: 'misc'
    },
    techsocial: {
      slug: 'techsocial',
      category: 'misc'
    },
    'terminal-velocity': {
      slug: 'terminal-velocity',
      category: 'misc'
    },
    'the-29th-floor': {
      slug: 'the-29th-floor',
      category: 'misc'
    },
    'the-big-idea': {
      slug: 'the-big-idea',
      category: 'misc'
    },
    'the-big-story': {
      slug: 'the-big-story',
      category: 'misc'
    },
    'the-code-war': {
      slug: 'the-code-war',
      category: 'technology'
    },
    'the-creator-economy': {
      slug: 'the-creator-economy',
      category: 'misc'
    },
    'the-shape-of-tomorrow': {
      slug: 'the-shape-of-tomorrow',
      category: 'misc'
    },
    'the-fast-company-innovation-festival': {
      slug: 'the-fast-company-innovation-festival',
      category: 'misc'
    },
    'fast-company-innovation-festival': {
      slug: 'fast-company-innovation-festival',
      category: 'misc'
    },
    'the-future-of-collaboration': {
      slug: 'the-future-of-collaboration',
      category: 'misc'
    },
    'the-future-of-everything': {
      slug: 'the-future-of-everything',
      category: 'misc'
    },
    'the-future-of-policing': {
      slug: 'the-future-of-policing',
      category: 'misc'
    },
    'the-future-of-service-in-america': {
      slug: 'the-future-of-service-in-america',
      category: 'misc'
    },
    'the-future-of-work': {
      slug: 'the-future-of-work',
      category: 'misc'
    },
    'the-intern-economy': {
      slug: 'the-intern-economy',
      category: 'misc'
    },
    'the-legacy-of-1995': {
      slug: 'the-legacy-of-1995',
      category: 'misc'
    },
    'the-misfit-economy': {
      slug: 'the-misfit-economy',
      category: 'misc'
    },
    'the-new-magic': {
      slug: 'the-new-magic',
      category: 'misc'
    },
    'the-new-rules-of-work': {
      slug: 'the-new-rules-of-work',
      category: 'misc'
    },
    'the-new-rules-of-ai': {
      slug: 'the-new-rules-of-ai',
      category: 'misc'
    },
    'new-rules-of-ai': {
      slug: 'new-rules-of-ai',
      category: 'misc'
    },
    'the-new-business-of-growing-old': {
      slug: 'the-new-business-of-growing-old',
      category: 'misc'
    },
    'the-new-business-of-food': {
      slug: 'the-new-business-of-food',
      category: 'misc'
    },
    'the-new-capitalism': {
      slug: 'the-new-capitalism',
      category: 'misc'
    },
    'the-future-of-kids-entertainment': {
      slug: 'the-future-of-kids-entertainment',
      category: 'misc'
    },
    'the-other-side': {
      slug: 'the-other-side',
      category: 'misc'
    },
    'the-pivot': {
      slug: 'the-pivot',
      category: 'misc'
    },
    'the-purposeful-ceo': {
      slug: 'the-purposeful-ceo',
      category: 'misc'
    },
    'the-rebuilders': {
      slug: 'the-rebuilders',
      category: 'misc'
    },
    'the-recommender': {
      slug: 'the-recommender',
      category: 'misc'
    },
    'the-road-ahead': {
      slug: 'the-road-ahead',
      category: 'misc'
    },
    'the-rules-of-social-media': {
      slug: 'the-rules-of-social-media',
      category: 'misc'
    },
    'the-science-of-work': {
      slug: 'the-science-of-work',
      category: 'misc'
    },
    'the-sensor-revolution': {
      slug: 'the-sensor-revolution',
      category: 'misc'
    },
    'the-thread': {
      slug: 'the-thread',
      category: 'misc'
    },
    'the-ultimate-urban-utility-bike': {
      slug: 'the-ultimate-urban-utility-bike',
      category: 'misc'
    },
    'the-valley': {
      slug: 'the-valley',
      category: 'misc'
    },
    'the-vow': {
      slug: 'the-vow',
      category: 'advertorial'
    },
    'the-walk-through': {
      slug: 'the-walk-through',
      category: 'misc'
    },
    'the-y-combinator-chronicles': {
      slug: 'the-y-combinator-chronicles',
      category: 'misc'
    },
    'the-year-in-post-truth': {
      slug: 'the-year-in-post-truth',
      category: 'misc'
    },
    'then-and-now': {
      slug: 'then-and-now',
      category: 'misc'
    },
    'tim-cooks-apple': {
      slug: 'tim-cooks-apple',
      category: 'misc'
    },
    'today-in-tabs': {
      slug: 'today-in-tabs',
      category: 'misc'
    },
    'top-5-ads': {
      slug: 'top-5-ads',
      category: 'misc'
    },
    'top-jobs': {
      slug: 'top-jobs',
      category: 'misc'
    },
    tracking: {
      slug: 'tracking',
      category: 'misc'
    },
    'travel-smarter': {
      slug: 'travel-smarter',
      category: 'misc'
    },
    'tribeca-film-festival': {
      slug: 'tribeca-film-festival',
      category: 'misc'
    },
    'united-states-of-innovation': {
      slug: 'united-states-of-innovation',
      category: 'technology'
    },
    unplug: {
      slug: 'unplug',
      category: 'misc'
    },
    unreasonables: {
      slug: 'unreasonables',
      category: 'misc'
    },
    upswing: {
      slug: 'upswing',
      category: 'misc'
    },
    'us-innovation': {
      slug: 'us-innovation',
      category: 'innovation'
    },
    'usa-can-this-brand-be-saved': {
      slug: 'usa-can-this-brand-be-saved',
      category: 'misc'
    },
    visualized: {
      slug: 'visualized',
      category: 'misc'
    },
    visualizing: {
      slug: 'visualizing',
      category: 'misc'
    },
    'visualizing-success': {
      slug: 'visualizing-success',
      category: 'misc'
    },
    wanderlust: {
      slug: 'wanderlust',
      category: 'misc'
    },
    wanted: {
      slug: 'wanted',
      category: 'misc'
    },
    'wearable-computing': {
      slug: 'wearable-computing',
      category: 'misc'
    },
    'wearables-week': {
      slug: 'wearables-week',
      category: 'misc'
    },
    wears: {
      slug: 'wears',
      category: 'misc'
    },
    'weekly-top-5': {
      slug: 'weekly-top-5',
      category: 'misc'
    },
    'well-to-do': {
      slug: 'well-to-do',
      category: 'technology'
    },
    'where-are-they-now': {
      slug: 'where-are-they-now',
      category: 'misc'
    },
    'whos-next': {
      slug: 'whos-next',
      category: 'innovation'
    },
    'why-here': {
      slug: 'why-here',
      category: 'misc'
    },
    'why-youre-fat': {
      slug: 'why-youre-fat',
      category: 'misc'
    },
    'women-heroes': {
      slug: 'women-heroes',
      category: 'leadership'
    },
    'women-in-tech-2009': {
      slug: 'women-in-tech-2009',
      category: 'leadership'
    },
    'women-in-tech-2010': {
      slug: 'women-in-tech-2010',
      category: 'leadership'
    },
    'women-in-tech-2011': {
      slug: 'women-in-tech-2011',
      category: 'leadership'
    },
    'women-to-watch': {
      slug: 'women-to-watch',
      category: 'advertorial'
    },
    'work-mode': {
      slug: 'work-mode',
      category: 'leadership'
    },
    'work-smart': {
      slug: 'work-smart',
      category: 'leadership'
    },
    'working-while-female': {
      slug: 'working-while-female',
      category: 'leadership'
    },
    'workplace-evolution': {
      slug: 'workplace-evolution',
      category: 'leadership'
    },
    'world-changing-ideas': {
      slug: 'world-changing-ideas',
      category: 'misc'
    },
    'world-changing-ideas-2015': {
      slug: 'world-changing-ideas-2015',
      category: 'misc'
    },
    'worth-the-risk': {
      slug: 'worth-the-risk',
      category: 'advertorial'
    },
    wwdc: {
      slug: 'wwdc',
      category: 'misc'
    },
    'your-most-productive-self': {
      slug: 'your-most-productive-self',
      category: 'misc'
    }
  },
  tagLanderOverrides: {
    'lincoln-mkc': {
      slug: '*Lincoln_MKC_advertorial',
      category: 'advertorial'
    },
    mckinsey__company_advertorial: {
      slug: '*McKinsey__Company_advertorial',
      category: 'advertorial'
    }
  },
  definitions: {
    brandworkstop_mobile: {
      size: [120, 35],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[120, 35]]
        }
      ]
    },
    brandworkstop: {
      size: [120, 35],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[120, 35]]
        }
      ]
    },
    welcome: {
      size: [600, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[600, 400], [640, 480], [600, 600]]
        },
        {
          viewport: [640, 0],
          slot: [[600, 400], [640, 480], [600, 600]]
        },
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250]]
        }
      ]
    },
    flexiblebillboard: {
      size: [728, 90],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[728, 90], [970, 250], [3, 1]]
        },
        {
          viewport: [640, 0],
          slot: [[728, 90], [3, 1]]
        }
      ]
    },
    flexiblebillboard_1: {
      size: [728, 90],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[728, 90], [970, 250], [3, 1]]
        },
        {
          viewport: [640, 0],
          slot: [[728, 90], [3, 1]]
        }
      ]
    },
    flexiblebillboard_2: {
      size: [728, 90],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[728, 90], [970, 250], [3, 1]]
        },
        {
          viewport: [640, 0],
          slot: [[728, 90], [3, 1]]
        }
      ]
    },
    flexiblebillboard_3: {
      size: [728, 90],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[728, 90], [970, 250], [3, 1]]
        },
        {
          viewport: [640, 0],
          slot: [[728, 90], [3, 1]]
        }
      ]
    },
    flexiblebillboard_4: {
      size: [728, 90],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[728, 90], [970, 250], [3, 1]]
        },
        {
          viewport: [640, 0],
          slot: [[728, 90], [3, 1]]
        }
      ]
    },
    flexiblebillboard_5: {
      size: [728, 90],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[728, 90], [970, 250], [3, 1]]
        },
        {
          viewport: [640, 0],
          slot: [[728, 90], [3, 1]]
        }
      ]
    },
    flexiblebillboard_6: {
      size: [728, 90],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[728, 90], [970, 250], [3, 1]]
        },
        {
          viewport: [640, 0],
          slot: [[728, 90], [3, 1]]
        }
      ]
    },
    flexiblepushdown: {
      size: [728, 90],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [
            [728, 90],
            [970, 90],
            [970, 250],
            [970, 415],
            [970, 600],
            [6, 6],
            [3, 1]
          ]
        },
        {
          viewport: [640, 0],
          slot: [[728, 90], [6, 6], [2, 2], [3, 1]]
        }
      ]
    },
    flexiblehalfpage: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    flexiblehalfpage_1: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    flexiblehalfpage_1_sidebarVideo: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250]]
        }
      ]
    },
    flexiblehalfpage_2: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    flexiblehalfpage_3: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    flexiblehalfpage_4: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    flexiblehalfpage_5: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    flexiblehalfpage_6: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    flexiblehalfpage_7: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    flexiblehalfpage_8: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    flexiblehalfpage_9: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    flexiblehalfpage_10: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    flexiblehalfpage_11: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    flexiblehalfpage_12: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    slideshowhalfpage: {
      size: [300, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600]]
        }
      ]
    },
    fixedrectangle: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [300, 250]
        },
        {
          viewport: [640, 0],
          slot: [300, 250]
        }
      ]
    },
    fixedrectangle_2: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [300, 250]
        },
        {
          viewport: [640, 0],
          slot: [300, 250]
        }
      ]
    },
    fixedrectangle_3: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [300, 250]
        },
        {
          viewport: [640, 0],
          slot: [300, 250]
        }
      ]
    },
    fixedrectangle_news: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [300, 250]
        },
        {
          viewport: [640, 0],
          slot: [300, 250]
        }
      ]
    },
    slideshowrectangle: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [300, 250]
        },
        {
          viewport: [640, 0],
          slot: [300, 250]
        },
        {
          viewport: [0, 0],
          slot: [300, 250]
        }
      ]
    },
    mobileparallax_1: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [640, 1138], [3, 1]]
        }
      ]
    },
    mobileparallax_2: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [640, 1138], [3, 1]]
        }
      ]
    },
    mobilerectangle: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobilerectangle_1: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobilerectangle_2: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobilerectangle_3: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobilerectangle_4: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobilerectangle_5: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobilerectangle_6: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobilerectangle_7: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobilerectangle_8: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobilerectangle_9: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobilerectangle_10: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobilerectangle_11: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobilerectangle_12: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [320, 250], [2, 2], [3, 1]]
        }
      ]
    },
    mobileleaderboard: {
      size: [320, 50],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[300, 250], [6, 6]]
        }
      ]
    },
    mobileleaderboard_short: {
      size: [320, 50],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[320, 50], [300, 50], [320, 100]]
        }
      ]
    },
    mobile_adhesive: {
      size: [320, 50],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[320, 50], [300, 50]]
        }
      ]
    },
    flexibleleaderboard: {
      size: [728, 90],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[728, 90], [2, 2], [3, 1]]
        },
        {
          viewport: [640, 0],
          slot: [[728, 90], [2, 2], [3, 1]]
        }
      ]
    },
    slideshowleaderboard: {
      size: [728, 90],
      sizeMapping: [
        {
          viewport: [640, 0],
          slot: [[728, 90], [2, 2], [3, 1]]
        }
      ]
    },
    flexibleinterrupter: {
      size: [970, 600],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[970, 415], [970, 600], [2, 2], [3, 1]]
        },
        {
          viewport: [640, 0],
          slot: [[728, 90], [2, 2], [3, 1]]
        }
      ]
    },
    flexiblelogo: {
      size: [120, 90],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[88, 31], [120, 60], [120, 90]]
        }
      ]
    },
    flexibleportrait: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    flexibleportrait_1: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    flexibleportrait_2: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    flexibleportrait_3: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    flexibleportrait_4: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    flexibleportrait_5: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    flexibleportrait_6: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    flexibleportrait_7: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    flexibleportrait_8: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    flexibleportrait_9: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    flexibleportrait_10: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    flexibleportrait_11: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    flexibleportrait_12: {
      size: [300, 1050],
      sizeMapping: [
        {
          viewport: [1024, 0],
          slot: [[300, 250], [300, 600], [300, 1050]]
        }
      ]
    },
    oop: {
      size: [1, 1],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [1, 1]
        }
      ]
    },
    nativecollectionmodule_01: {
      size: [3, 3],
      sizeMapping: [
        {
          viewport: [3, 3],
          slot: [3, 3]
        }
      ]
    },
    nativetile_1: {
      size: [3, 3],
      sizeMapping: [
        {
          viewport: [3, 3],
          slot: [3, 3]
        }
      ]
    },
    nativetile_2: {
      size: [3, 3],
      sizeMapping: [
        {
          viewport: [3, 3],
          slot: [3, 3]
        }
      ]
    },
    nativetile_3: {
      size: [3, 3],
      sizeMapping: [
        {
          viewport: [3, 3],
          slot: [3, 3]
        }
      ]
    },
    nativetile_4: {
      size: [3, 3],
      sizeMapping: [
        {
          viewport: [3, 3],
          slot: [3, 3]
        }
      ]
    },
    native_homepagefeature: {
      size: [3, 3],
      sizeMapping: [
        {
          viewport: [3, 3],
          slot: [3, 3]
        }
      ]
    },
    native_recommendationlink: {
      size: [3, 3],
      sizeMapping: [
        {
          viewport: [3, 3],
          slot: [3, 3]
        }
      ]
    },
    native_sponsoredtile: {
      size: [3, 3],
      sizeMapping: [
        {
          viewport: [3, 3],
          slot: [3, 3]
        }
      ]
    },
    native_mid_article_inject: {
      size: [3, 3],
      sizeMapping: [
        {
          viewport: [3, 3],
          slot: [3, 3]
        }
      ]
    },
    mid_article_inject: {
      size: [300, 250],
      sizeMapping: [
        {
          viewport: [640, 0],
          slot: [300, 250]
        }
      ]
    },
    native_infinitescroll: {
      size: [3, 3],
      sizeMapping: [
        {
          viewport: [3, 3],
          slot: [3, 3]
        }
      ]
    },
    native_second: {
      size: [4, 4],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [4, 4]
        }
      ]
    },
    mobile_video_insertion_test: {
      size: [8, 1],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [8, 1]
        }
      ]
    },
    sponsorlogo: {
      size: [[120, 30], [220, 50]],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [[120, 30], [220, 50]]
        }
      ]
    },
    welcomemat: {
      size: [6, 6],
      sizeMapping: [
        {
          viewport: [6, 6],
          slot: [6, 6]
        }
      ]
    },
    welcome_ad_video_pixel: {
      size: [1, 1],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [1, 1]
        }
      ]
    }
  }
};
